import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';
import type { BudgetForecastEntry, BudgetForecastUser } from 'lumen/models';

export default class BudgetForecastVersion extends Model {
  [Type] = 'budget-forecast/version';

  @belongsTo('budget-forecast/user', { async: false, inverse: null })
  declare createdBy: BudgetForecastUser | null;

  @belongsTo('budget-forecast/entry', { async: false, inverse: 'versions' })
  declare entry: BudgetForecastEntry;

  @attr('dayjs') declare date: NonNullable<DayjsTransformReturn>;
}
